import styled from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import { keepBlockSelectionAttribute } from '../constants'

export const Container = styled.aside.attrs({ [keepBlockSelectionAttribute]: '' })`
  display: flex;
  flex-direction: column;
  width: 362px;
  flex-shrink: 0;
  background-color: ${props => props.theme.colors.background.primary};
  border-left: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  min-height: ${props => props.theme.size.XL};
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp24};
  border-bottom: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
`

export const HeaderLabel = styled(Text)`
  color: ${props => props.theme.colors.text.muted};
`

export const Settings = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: ${props => props.theme.spacing.sp24};
  padding: ${props => props.theme.spacing.sp24};
`

export const Intro = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const Description = styled(Text)`
  color: ${props => props.theme.colors.text.muted};
`

export const HiddenBlocks = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`

export const HiddenBlocksToggle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.sp16};
`

export const Modes = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${props => props.theme.spacing.sp24};
  padding: ${props => props.theme.spacing.sp24};
  border-top: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
  overflow-y: auto;
`
